
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/duedatecalculator",
      function () {
        return require("private-next-pages/tools/duedatecalculator/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/duedatecalculator"])
      });
    }
  